import React from 'react'
import { Spin } from 'antd'
import './Loader.scss'

const Loader = () => {

    const indicator = (
        <div className="loader"></div>
    )

    return (
        <Spin
            fullscreen
            size='large'
            indicator={indicator}
        />
    )
}

export default Loader